export enum AWSUserRole {
  administrator = 'Administrator',
  debugger = 'Debugger',
}
